module.exports = __webpack_public_path__ + "static/media/expenses.b2c2abf5.gif";